<template>
  <div>
    <div class="title">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="b1" :to="{ path: '/ServiceMarket' }">授权接口</el-breadcrumb-item>
        <el-breadcrumb-item class="b2">查看文档</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div class="pageList">
        <div class="list">
         <div class="topTit"><img src="../../assets/images/fwq@2x.png" />{{data.name}}</div>
         <div class="infoBlock">
           <!-- <div>
             <div class="label">类型</div>
             <div class="valBox pl28">
               {{data.headers}}
             </div>
           </div> -->
           <div>
             <div class="label">返回类型</div>
             <div class="valBox pl28">
               {{ data.headers}}
             </div>
           </div>
            <div>
             <div class="label">描述</div>
             <div class="valBox pl28">
               {{ data.remark}}
             </div>
           </div>
         </div>

         <div class="infoBlock infoBlock1">
           <div>
             <div class="label">请求地址</div>
             <div class="valBox">
               <span>{{ getMethText(data.method) }}</span>
                {{ data.address}}
             </div>
           </div>



         </div>

         <div class="titBox">请求参数</div>
         <!--表格start-->
          <el-table
            :data="tableData"
            stripe
            style="width: 100%">
            <el-table-column
              prop="paramName"
              label="参数名称"
              width="180">
            </el-table-column>
            <el-table-column
              prop="required"
              label="是否必填"
              width="180">
              <template slot-scope="scope">
                {{scope.row.required ? '是' : '否'}}
              </template>
            </el-table-column>
            <el-table-column
              prop="paramType"
              label="参数类型">
              <template slot-scope="scope">
                {{ getParamTypeText(scope.row.paramType)}}
              </template>
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注">
            </el-table-column>
          </el-table>
         <!--表格end-->


         <div class="titBox">响应参数</div>
         <div class="codeWrap">
           <json-viewer
            :value="data.results"
            :expand-depth="5"
            :copyable="copyable"
            :sort="sort"
            @copied="onCopy"
          ></json-viewer>

          <!-- <prism-editor
            class="my-editor height-300"
              v-model="code"
              aria-disabled
              :highlight="highlighter"
              line-numbers
              :readonly="false"
              :tabSize="4"
              theme="my-awesome-json-theme"
              ></prism-editor> -->
         </div>
        </div>
        <!-- <div class="pageBox">
           <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next"
              :total="total">
            </el-pagination>
        </div> -->
      </div>
    </div>
  </div>

</template>

<script>
import {
    fetchApiDetail
  } from '@/api/api'

import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css";

export default {
  data() {
    return {
      data: null,
      tableData: [], // 参数表格
      code2: {
        code:200,
        msg: "成功",
      },
      copyable: {
        copyText: '复制',
        copiedText: '复制成功',
        timeout: 2000
      },
      sort: true,
      code: '{"code":1,"msg":"成功","data":{"totalElements":"2","content":[{"id":6,"name":"寻找代理商","details":"二级节点搭建","categoryId":5,"categoryName":"设备制造行业","contacts":"李先生","phone":"1555555555","budget":100.00,"enterpriseName":"太原科技","createTime":"2022-11-26 10:02:13","status":1,"reason":null},{"id":7,"name":"二级节点部署安全策略","details":"寻找安全防护专家，支持等保办理","categoryId":4,"categoryName":"化工行业","contacts":"刘女士","phone":"15366665652","budget":100.00,"enterpriseName":"山西智能制造科技","createTime":"2022-11-26 20:26:54","status":1,"reason":null}]}}',
    }
  },
  components: {
	 		PrismEditor
	 },
  created() {
    this.getDetail()
  },
  methods: {
    getMethText(num) {
      let str = ''
      if(num === 1) {
        str='POST'
      }else if(num === 2) {
        str='GET'
      }else if(num === 3) {
        str='PUT'
      }else if(num === 4) {
        str='DELETE'
      }
      return str
    },
    getParamTypeText(num) {
    let str = ''
      if(num == 1) {
        str='String'
      }else if(num == 2) {
        str='Integer'
      }else if(num == 3) {
        str='Long'
      }else if(num == 4) {
        str='Double'
      }else if(num == 5) {
        str='Boolean'
      }
      return str
    },
    getDetail() {
      let id = this.$route.query.data
      let params = {
        id,
      }
      fetchApiDetail(params).then(res => {
        this.data = res.data
        this.data.results = JSON.parse(this.data.results)
        this.tableData = JSON.parse(res.data.params)
      })
    },
    highlighter(code) {
      return highlight(code, languages.js); //returns html
    }
  }
}
</script>

<style scoped>
.title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #282F3D;
    padding-left: 30px;
    background: #fff;
  }

  .content {
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .pageList {
    width: 100%;
    height: calc(100vh - 180px);
    background: #FFFFFF;
    box-shadow: 1px 3px 16px 0px rgba(204, 211, 228, 0.51);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 20px 40px;
    overflow-y: scroll;
  }
  .pageBox{
    display: flex;
    justify-content: flex-end;
  }

/**代码块**/
  .my-editor {
	 background: #2d2d2d;
	 color: #ccc;
	 font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
	 font-size: 14px;
	 line-height: 1.5;
	 padding: 5px;
	}

	.prism-editor__textarea:focus {
	 outline: none;
	}

	/* 非必须 */
	.height-300 {
	 	height: 300px;
	}
  .topTit{
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    padding: 16px 0;
    background: url(../../assets/images/apiBj@2x.png) top right no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center
  }
  .topTit img {
    width: 18px;
    margin-left: 17px;
    margin-right: 12px;
  }
  .infoBlock{
    display: flex;
    justify-content: space-between;
    align-items:flex-start;
    padding-top: 28px;
  }
  .infoBlock > div:nth-child(1) {
    width: 46%;
  }
  .infoBlock > div:nth-child(2) {
    width: 46%;
  }
  .infoBlock1 > div:nth-child(1) {
    width: 100%;
  }
  .label{
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #8D97B9;
    line-height: 30px;
  }
  .valBox{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #1F222D;
    min-height: 50px;
    line-height: 50px;
    background: #F7F8FB;
    border-radius: 8px;
  }
  .pl28{
    padding-left: 18px;
  }
  .valBox span {
    width: 111px;
    height: 50px;
    background: rgba(15, 94, 255, 1);
    border-radius: 8px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    display: inline-block;
    text-align: center;
    margin-right: 32px;
  }
  .titBox{
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #1F222D;
    padding-left: 12px;
    position: relative;
    margin: 22px 0;
  }
  .titBox:after{
    display: block;
    content: "";
    width: 2px;
    height: 17px;
    background: #0F5EFF;
    border-radius: 1px;
    position: absolute;
    top: 4px;
    left: 0;
  }
  .codeWrap{
    border: 1px solid rgba(204, 211, 228, 0.51);
  }






/deep/ .b1 span.el-breadcrumb__inner.is-link{
  color: rgba(183, 192, 211, 1);
  font-weight: normal;
  font-size: 20px;
}
/deep/ .b2 .el-breadcrumb__inner {
  color: rgba(31, 34, 45, 1);
  font-size: 20px;
}
/deep/ .el-breadcrumb {
  line-height: 66px;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/console/ApiDetail.vue